import { Plugin, type ViewElement, type ViewNode } from 'ckeditor5';

export class ImagePreview extends Plugin {
  static get pluginName() {
    return 'ImagePreview';
  }

  static get requires() {
    return ['EasyImage'];
  }

  private _onClickHandler?: (sources: string[], index: number) => void;

  init() {
    const editor = this.editor;
    this._onClickHandler = editor.config.get('imagePreview.onClick');

    if (editor.isReadOnly) {
      this._addImagePreviewBehavior();
    }

    editor.on('change:isReadOnly', (_, __, isReadOnly) => {
      if (isReadOnly) {
        this._addImagePreviewBehavior();
      } else {
        this._removeImagePreviewBehavior();
      }
    });
  }

  private _addImagePreviewBehavior() {
    const editor = this.editor;
    const viewDocument = editor.editing.view.document;

    if (this._onClickHandler) {
      viewDocument.on('click', this._eventHandler);
    }
  }

  private readonly _eventHandler = (_: unknown, data: { domTarget: HTMLElement }) => {
    const imgElement = data.domTarget;

    if (imgElement.localName === 'img') {
      const sources: string[] = [];

      const { _onClickHandler, editor } = this;

      for (const value of editor.editing.view.document.getRoot()?.getChildren() ?? []) {
        this._traverse(value, sources);
      }

      if (sources.length > 0 && _onClickHandler) {
        const source = imgElement.getAttribute('src');
        const activeIndex = sources.indexOf(source ?? '');

        _onClickHandler(sources, Math.max(0, activeIndex));
      }
    }
  };

  private readonly _extractSource = (element: ViewElement, sources: string[]) => {
    const source = element.getAttribute('src');

    if (source) {
      sources.push(source);
    }
  };

  private _removeImagePreviewBehavior() {
    const editor = this.editor;
    const viewDocument = editor.editing.view.document;

    viewDocument.off('click', this._eventHandler);
  }

  private readonly _traverse = (node: ViewNode, sources: string[]) => {
    if (node.is('element')) {
      if (node.is('element', 'img')) {
        this._extractSource(node, sources);
      }

      for (const child of node.getChildren()) {
        this._traverse(child, sources);
      }
    }
  };
}
